import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

/** Empty state for the organization-level Activation Templates list: a document with a clock badge. */
const EmptyActivationTemplatesIcon = (props: any) => {
  const theme = useContext(ThemeContext);
  return (
    <svg height="156" width="216" fill="none" viewBox="0 0 216 156" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="108" cy="78" r="70" fill={theme.colors.selection} />
      <rect x="70" y="30" width="76" height="96" rx="8" fill="white" stroke="#EAEAEA" strokeWidth="1.5" />
      <rect x="82" y="48" width="40" height="6" rx="3" fill={theme.colors.primary.c100} />
      <rect x="82" y="62" width="52" height="6" rx="3" fill="#EAEAEA" />
      <rect x="82" y="76" width="52" height="6" rx="3" fill="#EAEAEA" />
      <rect x="82" y="90" width="34" height="6" rx="3" fill="#EAEAEA" />
      <circle cx="140" cy="112" r="24" fill={theme.colors.primary.c500} />
      <path
        d="M140 100v12l8 6"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle cx="140" cy="112" r="17" stroke="white" strokeWidth="2.5" fill="none" />
    </svg>
  );
};

export default EmptyActivationTemplatesIcon;
